class VariantDimensionsUpdater extends HTMLElement {
  constructor() {
    super();
    this.mainContainer = this.querySelector('.variant-dimensions');
    if (!this.mainContainer) return;

    // Check if the theme's pub/sub system is available
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      console.error('Variant Dimensions: Theme pub/sub system not found.');
      return;
    }

    try {
      // Find the main product-info element to get the data script
      const productInfo = this.closest('product-info');
      if (!productInfo) return;
      
      const variantDataEl = productInfo.querySelector('[data-variant-dimensions]');
      this.variantData = JSON.parse(variantDataEl.textContent);

      // Use the theme's 'subscribe' function to listen for the correct event
      subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
      
    } catch (e) {
      console.error('Variant Dimensions: Failed to initialize.', e);
    }
  }

  onVariantChange({ data }) {
    const { variant } = data;
    if (!variant) return;

    const heightValueEl = this.querySelector('[data-variant-dimension="height"]');
    const diameterValueEl = this.querySelector('[data-variant-dimension="diameter"]');
    
    const heightContainer = heightValueEl ? heightValueEl.closest('.variant-dimensions__item') : null;
    const diameterContainer = diameterValueEl ? diameterValueEl.closest('.variant-dimensions__item') : null;
    
    const currentVariantData = this.variantData[variant.id] || null;

    const heightValue = (currentVariantData && currentVariantData.height) ? currentVariantData.height.trim() : '';
    const diameterValue = (currentVariantData && currentVariantData.diameter) ? currentVariantData.diameter.trim() : '';

    if (!heightValue && !diameterValue) {
      this.mainContainer.style.display = 'none';
      return;
    } else {
      this.mainContainer.style.display = 'flex';
    }

    if (heightContainer) {
      if (heightValue) {
        heightValueEl.textContent = heightValue;
        heightContainer.style.display = 'flex';
      } else {
        heightContainer.style.display = 'none';
      }
    }

    if (diameterContainer) {
      if (diameterValue) {
        diameterValueEl.textContent = diameterValue;
        diameterContainer.style.display = 'flex';
      } else {
        diameterContainer.style.display = 'none';
      }
    }
  }
}

customElements.define('variant-dimensions-updater', VariantDimensionsUpdater);